
import {getDocs} from 'firebase/firestore'
import { ClassData } from "@/common-datatypes";
import { Component,Mixins} from "vue-property-decorator";
import Common from '@/mixins/common'

@Component

export default class Class extends Mixins(Common) {
  classes: ClassData[] = []
  isLoading = false
  orderBy: keyof ClassData = 'creationTime'

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      const theUserClasss = await getDocs(this.$getUserClassesQuery())
      this.classes = theUserClasss.docs.map( (doc) => {
        const row = doc.data() as ClassData
        return {classId: doc.id,...row}
      })
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  get children(): string[]{
    return this.$store.getters.myChildren || []
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
